export const defaultEditorContent = {
  type: "doc",
  content: [],
};
